module.exports = __webpack_public_path__ + "static/img/icon_gh.4dc85b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_gh.png
// module id = Q7QF
// module chunks = 1